import type {
  ComponentPropsWithoutRef,
  FC,
  HTMLAttributes,
  ReactNode,
} from 'react';
import { ActionModeProvider } from 'src/components/action-mode';
import { cn } from 'src/utils/cn';

export const LayoutContainer = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      className={cn(
        `
          grid gap-[3rem]
          [grid-template-areas:'sidebar'_'title'_'content']
          md:grid-cols-[1fr_5fr]
          md:[grid-template-areas:'._title'_'sidebar_content']
        `,
        className
      )}
      {...props}
    />
  );
};

export const LayoutTitle = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn(`[grid-area:title]`, className)} {...props} />;
};

export const LayoutContent = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn(`[grid-area:content]`, className)} {...props} />;
};

export const LayoutSidebar = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn(`[grid-area:sidebar]`, className)} {...props} />;
};

export const Sidebar: FC<
  HTMLAttributes<HTMLDivElement> & { children: ReactNode }
> = ({ className, children, ...rest }) => (
  <div
    className={cn(
      `rounded-none bg-white shadow-[0_0.1rem_0.1rem_rgba(0,0,0,0.05)]`,
      className
    )}
    {...rest}
  >
    <ActionModeProvider value={{ mode: 'sidebar-item' }}>
      {children}
    </ActionModeProvider>
  </div>
);
